import React from "react";
import AccessTypeFormContent from "../../../../../../components/common/PL/Forms/AccessTypeFormContent/AccessTypeFormContent";

type EventualContentFormProps = {
  formId: string;
  authorizations?: any[];
  disabled?: boolean;
};

const EventualContentForm: React.FC<EventualContentFormProps> = ({
  formId: _formId,
  authorizations,
  disabled = false,
}) => (
  <AccessTypeFormContent fieldPrefix="eventual" authorizations={authorizations} disabled={disabled} />
);

export default EventualContentForm;
